import { render } from "./Softwares.vue?vue&type=template&id=575d3e4e&scoped=true"
import script from "./Softwares.vue?vue&type=script&lang=js"
export * from "./Softwares.vue?vue&type=script&lang=js"

import "./Softwares.vue?vue&type=style&index=0&id=575d3e4e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575d3e4e"]])

export default __exports__